import type * as React from "react";
import { Suspense } from "react";
import { BookingStepFour } from "@/components/booking/BookingStepFour";
import { BookingStepOneSkeleton } from "@/components/booking/BookingStepOneSkeleton";

const BookingConfirmPage: React.FC = () => {
  return (
    <Suspense fallback={<BookingStepOneSkeleton />}>
      <BookingStepFour />
    </Suspense>
  );
};

export default BookingConfirmPage;
